import React from 'react';

import {Alert} from '@mui/material';
import {object} from 'prop-types';

import AreaIndicator from '@components/common/AreaIndicator.jsx';
import {getMinimumSQMCost} from './util.js';

const MinimumCostAlert = ({product, sx, ...props}) => {
  const minCost = getMinimumSQMCost(product);
  if (minCost <= 0) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{padding: theme => theme.spacing(0.5, 1), ...sx}}
      {...props}
    >
      This product has a minimum quota cost of{' '}
      <AreaIndicator squareMeters={minCost} /> per feature.
    </Alert>
  );
};

MinimumCostAlert.propTypes = {
  product: object.isRequired,
  sx: object,
};

export default MinimumCostAlert;
